// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import singleProject from './routes/project';

import aboutUs from './routes/about';
import SwupBodyClassPlugin from '@swup/body-class-plugin';

// Swup setup
import Swup from 'swup';
const options = {
	containers: [
			'#body-wrapper',
	],
	plugins: [
		new SwupBodyClassPlugin(),
	],
};
const swup = new Swup(options);

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  singleProject,
});

// Generic events - these are loaded once only and would not re-run on Swup page changes
jQuery(document).ready(() => {
	// Place one off code here - such as click events for the menu
	setup_menu_trigger();
});


// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Load Events when using Swup
swup.on('contentReplaced', () => routes.loadEvents());

function setup_menu_trigger()
{	
	$('.menu-trigger').click(function (e){

		e.preventDefault();
		let body = $('body');
		if(body.hasClass('menu-active'))
		{
			console.log('1');
			body.removeClass('menu-active');
		}
		else
		{
			console.log('2');

			body.addClass('menu-active');
		}
	});
}



// WEBPACK FOOTER //
// ./scripts/main.js